import {Routes} from '@angular/router';
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import {importProvidersFrom} from '@angular/core';
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineObjectService,
  StoreModule
} from '@softline/core';
import {
  SOFTLINE_FEATURE_COUPON,
  SOFTLINE_FEATURE_COUPON_DAILY_BALANCE, SOFTLINE_PERMISSION_COUPON_CARD,
  SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION
} from './coupon-app.shared';
import {DailyBalanceStore} from './store/daily-balance.store';
import {COUPON_RESOURCE_PATH, COUPON_TRANSACTION_RESOURCE_PATH, DAILY_BALANCE_RESOURCE_PATH} from './coupon-app.api';
import {CouponStore} from './store/coupon.store';

export const gutscheinkartenRoutes: Routes = [
  {
    path: 'gutscheinkarten',
    loadComponent: () => import('./pages/coupon-app.component').then(o => o.CouponAppComponent),
    children: [
      {path: 'charge', loadComponent: () => import('./pages/charge-coupon/charge-coupon.component').then(o => o.ChargeCouponComponent)},
      {path: 'existing', loadComponent: () => import('./pages/existing-start/existing-start.component').then(o => o.ExistingStartComponent)},
      {path: 'redeem', loadComponent: () => import('./pages/redeem-coupon/redeem-coupon.component').then(o => o.RedeemCouponComponent)},
      {path: 'daily-balance', loadComponent: () => import('./pages/daily-balance/daily-balance.component').then(o => o.DailyBalanceComponent)},
      {path: '', loadComponent: () => import('./pages/coupon-start/coupon-start.component').then(o => o.CouponStartComponent)},
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_COUPON_CARD},
    providers: [
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_COUPON_DAILY_BALANCE,
          feature: DailyBalanceStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineObjectService(service, DAILY_BALANCE_RESOURCE_PATH),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_COUPON,
          feature: CouponStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineObjectService(service, COUPON_RESOURCE_PATH),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
            {
              provide: SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION,
              useFactory: (service: ConnectionHttpService) => new SoftlineObjectService(service, COUPON_TRANSACTION_RESOURCE_PATH),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        })
      )
    ]
  },
];
